import React, { useState, useEffect } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import Button from "components/CustomButtons/CustomButton.js";
import Avatar from "@material-ui/core/Avatar";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CustomModal from "components/CustomModal/Modal.js";
import CustomButton from "components/CustomButtons/CustomButton";

import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import { sanatizeMessageHtml, setDataUser } from "components/Utils/utils.js";

import { getUserData, saveUserData } from "../Services/UsersService.js";
import { Catalogs } from "views/Services/CatalogsService";
import { useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { RotatingLines } from "react-loader-spinner";
import Snackbar from "components/Snackbar/Snackbar.js";
import { Grid } from "@material-ui/core";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

const phoneCountryOptions = [
  { value: "1", label: "USA/Canada (+1)" },
  { value: "52", label: "Mexico (+52)" },
];

const lobOptions = [
  { value: "1", label: "Sanborn's" },
  { value: "2", label: "Arriba!" },
];
const useStyles = makeStyles(styles);

const UserStep1 = ({
  roles = [],
  agencies = [],
  countries = [],
  states = [],
  userData = {},
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    role: userData.role || "",
    agency: userData.agency || "",
    lob: userData.lob || "1",
    username: userData.username || "",
    pass1: "",
    email: userData.email || "",
    fname: userData.fname || "",
    mname: userData.mname || "",
    lname: userData.lname || "",
    address: userData.address || "",
    city: userData.city || "",
    country: userData.country || "",
    state: userData.state || "",
    zipcode: userData.zipcode || "",
    pobox: userData.pobox || "",
    phone: userData.phone || "",
    fax: userData.fax || "",
    phone_country: userData.phone_country || "1",
    avatar: userData.avatar || "",
    catalogs: { roles: [], agencies: [], countries: [], states: [] },
  });

  const routeParams = useParams();
  const { agencyId, id } = routeParams;

  const classes = useStyles();

  useEffect(() => {
    if (localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }
    if (id > 0) {
      getUser();
    } else {
      getCatalogs();
    }
  }, []);

  useEffect(() => {
    validateComplete(form);
  }, [form]);
  const validateComplete = (data) => {
    let reqPropertiesProfile = [
      "user_role_id",
      "first_name",
      "last_name",
      "phone_country",
    ];
    let reqPropertiesUser = ["username", "email"];

    let allPropertiesValid = reqPropertiesProfile.every((prop) => {
      const valueProp =
        typeof data?.Profile?.[prop] === "string"
          ? data?.Profile?.[prop].trim()
          : data?.Profile?.[prop];
      return valueProp !== undefined && valueProp !== null && valueProp !== "";
    });
    allPropertiesValid =
      allPropertiesValid &&
      reqPropertiesUser.every((prop) => {
        const valueProp =
          typeof data?.User?.[prop] === "string"
            ? data?.User?.[prop].trim()
            : data?.User?.[prop];
        return (
          valueProp !== undefined && valueProp !== null && valueProp !== ""
        );
      });
    setIsCompleted(allPropertiesValid);
  };

  const [avatarPreview, setAvatarPreview] = useState("");
  const [orderDataSuccess, setOrderDataSuccess] = useState({});
  const [modalSuccess, setModalSuccess] = useState(false);
  const [filteredStates, setFilteredStates] = useState([]);
  const [isCompleted, setIsCompleted] = useState(false);
  const [toastMessage, setToastMessage] = useState(false);
  const [alertLoading, setAlertLoading] = React.useState(null);
  const [messageToast, setMessageToast] = useState("");
  const [typeToast, setTypeToast] = useState("");

  // Maneja cambios en los inputs
  const handleInputProfileChange = (e) => {
    let { name, value } = e.target;
    if (name === "country_id") {
      const filteredStatesData = form?.catalogs?.states.filter(
        (state) => state.country_id.toString() === value.toString()
      );
      setFilteredStates(filteredStatesData);
    }
    if (name === "readonly") {
      value = form.Profile.readonly === "1" ? "0" : "1";
    }
    setForm((prev) => ({
      ...prev,
      Profile: {
        ...prev.Profile,
        [name]: value,
      },
    }));
  };

  // Maneja cambios en los inputs
  const handleInputUserChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      User: { ...prev.User, [name]: value },
    }));
  };

  // Maneja cambios en selects
  const handleSelectChange = (e) => {
    console.log(e.target);
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Maneja la carga de imagen
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({
        ...prev,
        Profile: {
          ...prev.Profile,
          files: file,
        },
      }));
      const reader = new FileReader();
      reader.onload = (ev) => setAvatarPreview(ev.target.result);
      reader.readAsDataURL(file);
    }
  };

  const getUser = async () => {
    const resultSubmit = await dispatch(getUserData({ id: id }));
    setForm(resultSubmit.payload.data);
    const filteredStatesData = resultSubmit.payload.data.catalogs.states.filter(
      (state) =>
        state.country_id.toString() ===
        resultSubmit.payload.data.Profile.country_id.toString()
    );
    if (
      resultSubmit.payload.data.Profile.extension &&
      resultSubmit.payload.data.Profile.avatar
    ) {
      setAvatarPreview(
        `data:image/${resultSubmit.payload.data.Profile.extension};base64,${resultSubmit.payload.data.Profile.avatar}`
      );
    }
    setFilteredStates(filteredStatesData);
  };

  const getCatalogs = async () => {
    const result = await dispatch(
      Catalogs({ userType: localStorage.getItem("userType") })
    );
    if (result.payload.result) {
      setForm((prev) => ({
        ...prev,
        Profile: {
          ...prev.Profile,
          agency: agencyId > 0 ? agencyId : 0,
        },
        catalogs: {
          roles: result.payload.catalogs.roles,
          agencies: result.payload.catalogs.agencies,
          countries: result.payload.catalogs.countries,
          states: result.payload.catalogs.states,
        },
      }));
    }
  };

  const loadingAlert = () => {
    setAlertLoading(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={<h5 style={{ color: "black" }}>{"Loading"}</h5>}
        allowEscape={false}
        closeOnClickOutside={false}
        showConfirm={false}
        showCancel={false}
      >
        <RotatingLines
          strokeColor="gray"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </SweetAlert>
    );
  };

  const saveUser = async (dataSend) => {
    if (isCompleted) {
      setToastMessage(false);
      let dataUser = setDataUser(dataSend, id);
      loadingAlert();
      const resultSubmit = await dispatch(saveUserData(dataUser));
      setAlertLoading(null);
      if (resultSubmit.payload) {
        if (resultSubmit.payload.result) {
          setOrderDataSuccess(resultSubmit.payload);
          setModalSuccess(true);
        } else {
          if (resultSubmit.payload.message.errors) {
            let messageToast = "<ul>";
            resultSubmit.payload.message.errors.map(
              (error, index) =>
                (messageToast += `<li key=${index}>${error.Message}</li>`)
            );
            messageToast += `</ul>`;
            setMessageToast(messageToast);
            setOpenModalError(true);
          }
        }
      } else {
        let mensaje = "\n";
        for (const key in resultSubmit.payload.message) {
          mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
        }
      }
    } else {
      setTypeToast("danger");
      let errorMessageIssue = "Please check the information in the form";
      setMessageToast(errorMessageIssue);
      setToastMessage(true);
    }
  };

  const successPolicy = () => {
    if (agencyId > 0) {
      window.location.href = `/admin/agency/${agencyId}`;
    } else {
      window.location.href = `/`;
    }
  };

  return (
    <GridContainer
      justifyContent="center"
      alignItems="center"
      xs={12}
      sm={12}
      md={8}
      style={{ margin: "auto" }}
    >
      <Card>
        <CardBody>
          {alertLoading}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              saveUser(form);
            }}
            encType="multipart/form-data"
          >
            <GridContainer>
              <GridItem xs={12} sm={6} md={3}>
                <CustomSelect
                  labelText="Role"
                  menuItems={[
                    { value: "", label: "-- Select --" },
                    ...form?.catalogs?.roles.map((r) => ({
                      value: r.id,
                      label: r.name,
                    })),
                  ]}
                  inputProps={{
                    name: "user_role_id",
                    value: form?.Profile?.user_role_id,
                    onChange: handleInputProfileChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Read Only"
                  inputProps={{
                    name: "readonly",
                    type: "checkbox",
                    checked: form?.Profile?.readonly === "1" ? true : false,
                    onChange: handleInputProfileChange,
                    style: { height: "20px" },
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              {agencyId > 0 ? null : (
                <GridItem xs={12} sm={6} md={3}>
                  <CustomSelect
                    labelText="Agency"
                    menuItems={[
                      { value: "", label: "-- Select --" },
                      ...form.catalogs.agencies.map((a) => ({
                        value: a.id,
                        label: `${a.producer_code} - ${a.agency_name}`,
                      })),
                    ]}
                    inputProps={{
                      name: "agency",
                      value: form?.Profile?.agency,
                      onChange: handleInputProfileChange,
                      required: true,
                    }}
                    formControlProps={{ fullWidth: true }}
                  />
                </GridItem>
              )}
              <GridItem xs={12} sm={6} md={3}>
                <CustomSelect
                  labelText="Line Of Business"
                  menuItems={lobOptions}
                  inputProps={{
                    name: "lob_id",
                    value: form?.Profile?.lob_id,
                    onChange: handleInputProfileChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Username"
                  inputProps={{
                    name: "username",
                    value: form?.User?.username,
                    onChange: handleInputUserChange,
                    minLength: 7,
                    maxLength: 30,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Password"
                  inputProps={{
                    name: "pass1",
                    type: "password",
                    value: form?.User?.pass1,
                    onChange: handleInputUserChange,
                    maxLength: 30,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Email"
                  inputProps={{
                    name: "email",
                    value: form?.User?.email,
                    onChange: handleInputUserChange,
                    type: "email",
                    maxLength: 100,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="First Name"
                  inputProps={{
                    name: "first_name",
                    value: form?.Profile?.first_name,
                    onChange: handleInputProfileChange,
                    maxLength: 30,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Middle Name"
                  inputProps={{
                    name: "middle_initial",
                    value: form?.Profile?.middle_initial,
                    onChange: handleInputProfileChange,
                    maxLength: 10,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Last Name"
                  inputProps={{
                    name: "last_name",
                    value: form?.Profile?.last_name,
                    onChange: handleInputProfileChange,
                    maxLength: 30,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Address"
                  inputProps={{
                    name: "address",
                    value: form?.Profile?.address,
                    onChange: handleInputProfileChange,
                    maxLength: 40,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="City"
                  inputProps={{
                    name: "city",
                    value: form?.Profile?.city,
                    onChange: handleInputProfileChange,
                    maxLength: 30,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomSelect
                  labelText="Country"
                  menuItems={[
                    { value: "", label: "-- Select --" },
                    ...form?.catalogs?.countries.map((c) => ({
                      value: c.id,
                      label: c.name,
                    })),
                  ]}
                  inputProps={{
                    name: "country_id",
                    value: form?.Profile?.country_id,
                    onChange: handleInputProfileChange,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomSelect
                  labelText="State"
                  menuItems={[
                    { value: "", label: "-- Select --" },
                    ...filteredStates.map((s) => ({
                      value: s.id,
                      label: s.name,
                    })),
                  ]}
                  inputProps={{
                    name: "state_id",
                    value: form?.Profile?.state_id,
                    onChange: handleInputProfileChange,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Zip Code"
                  inputProps={{
                    name: "zipcode",
                    value: form?.Profile?.zipcode,
                    onChange: handleInputProfileChange,
                    maxLength: 10,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="PO Box"
                  inputProps={{
                    name: "pobox",
                    value: form?.Profile?.pobox,
                    onChange: handleInputProfileChange,
                    maxLength: 30,
                    type: "number",
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Telephone"
                  inputProps={{
                    name: "phone",
                    value: form?.Profile?.phone,
                    onChange: handleInputProfileChange,
                    maxLength: 30,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomInput
                  labelText="Fax"
                  inputProps={{
                    name: "fax",
                    value: form?.Profile?.fax,
                    onChange: handleInputProfileChange,
                    maxLength: 30,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <CustomSelect
                  labelText="Phone Country"
                  menuItems={phoneCountryOptions}
                  inputProps={{
                    name: "phone_country",
                    value: form?.Profile?.phone_country,
                    onChange: handleInputProfileChange,
                    required: true,
                  }}
                  formControlProps={{ fullWidth: true }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                  }}
                >
                  <Avatar
                    src={avatarPreview}
                    alt="Avatar"
                    style={{ width: 80, height: 80 }}
                  />
                  <input
                    type="file"
                    name="avatar"
                    accept="image/*"
                    onChange={handleAvatarChange}
                    style={{ marginLeft: 16 }}
                  />
                </div>
              </GridItem>
            </GridContainer>
            <GridContainer
              container
              justifyContent="space-between"
              alignItems="center"
              style={{ minHeight: "100px", marginTop: "20px" }}
            >
              <GridItem xs={4}>
                <Button
                  id={"cancelUser"}
                  type="button"
                  variant="outlined"
                  onClick={(event) => {
                    window.location.href = "/admin/agency/" + agencyId;
                  }}
                  style={{ width: "100%" }}
                >
                  {t("Cancel")}
                </Button>
              </GridItem>
              <GridItem xs={4} />
              <GridItem xs={4}>
                <Button
                  id={"continueUser"}
                  type="submit"
                  onClick={(event) => {
                    console.log("submit");
                  }}
                  disabled={!isCompleted}
                  variant="green"
                  style={{ width: "100%" }}
                >
                  {t("creditCard.saveButton")}
                </Button>
              </GridItem>
            </GridContainer>
          </form>
          <CustomModal
            title=""
            isOpen={modalSuccess}
            onClose={() => successPolicy()}
            privacy={false}
            id={"successModal"}
          >
            <GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <div class="sa">
                    <div class="sa-success">
                      <div class="sa-success-tip"></div>
                      <div class="sa-success-long"></div>
                      <div class="sa-success-placeholder"></div>
                      <div class="sa-success-fix"></div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <GridItem xs={12}>
                <p style={{ fontSize: "20px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanatizeMessageHtml(orderDataSuccess.message),
                    }}
                  ></div>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <CustomButton
                  id="continueUser"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    successPolicy();
                  }}
                  block
                >
                  Ok
                </CustomButton>
              </GridItem>
            </GridContainer>
          </CustomModal>
          <Snackbar
            style={{ zIndex: "3000" }}
            place="br"
            color={typeToast}
            message={messageToast}
            open={toastMessage}
            closeNotification={() => setToastMessage(false)}
            close
          />
        </CardBody>
      </Card>
    </GridContainer>
  );
};

export default UserStep1;
